export default __webpack_public_path__ + "static/media/sec-4.7a5e5647.png";